<template>
  <v-layout row wrap>
    <v-flex xs12>
      <h4 class="mb-3">Weekly Checkin usings a 5 star rating system to track how your previous week went.</h4>
      <p>
        <strong>Nutrition:</strong><br>
        How well did you stick to your Macros/Calories, are you struggling with anything, did you go massively over or under on any day? Consume enough water, fruit and veg? Etc.
      </p>

      <p>
        <strong>Training:</strong><br>
        How you feel you performed, did you complete all sessions, did you progress with weights? Etc.
      </p>

      <p v-if="userProfile.one2one">
        <strong>Sleep:</strong><br>
        Did you sleep for 7-8 hours per night? Was your sleep broken or disrupted? Do you feel your sleep affected your performance? Etc.
      </p>

      <p v-if="userProfile.one2one">
        <strong>Work:</strong><br>
        How stressful has your work week been? Do you feel your work output has been affected by your training/nutrition? Do you feel your training or nutrition has been effected by your work week? Etc.
      </p>

      <p>
        <strong>Weeks Summary:</strong><br>
        How do you feel this week has been on a whole?
      </p>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      userProfile: 'userProfile'
    })
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/members/static/checkinInfo.vue